import type { Setting } from "@/payload-types";
import type { SocialMediaLink } from "./footer-utils";

export type SocialLink = {
  label: string;
  url: string;
};

export function buildFooterSocialIcons(
  profiles?: Setting["socialProfiles"] | null
): SocialMediaLink[] {
  if (!profiles) return [];

  const links: SocialMediaLink[] = [];
  if (profiles.facebook) links.push({ platform: "facebook", url: profiles.facebook });
  if (profiles.instagram) links.push({ platform: "instagram", url: `https://instagram.com/${profiles.instagram}` });
  if (profiles.linkedin) links.push({ platform: "linkedin", url: profiles.linkedin });
  return links;
}

export function buildSocialLinks(
  profiles?: Setting["socialProfiles"] | null
): SocialLink[] {
  if (!profiles) return [];

  const links: SocialLink[] = [];

  if (profiles.facebook) links.push({ label: "Facebook", url: profiles.facebook });
  if (profiles.instagram) links.push({ label: "Instagram", url: `https://instagram.com/${profiles.instagram}` });
  if (profiles.twitter) links.push({ label: "X (Twitter)", url: `https://twitter.com/${profiles.twitter}` });
  if (profiles.linkedin) links.push({ label: "LinkedIn", url: profiles.linkedin });
  if (profiles.youtube) links.push({ label: "YouTube", url: profiles.youtube });
  if (profiles.tiktok) links.push({ label: "TikTok", url: `https://www.tiktok.com/@${profiles.tiktok}` });
  if (profiles.googleBusiness) links.push({ label: "Google Business", url: profiles.googleBusiness });

  return links;
}
